import { Injectable, signal } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root', // Ensure it's available globally
})
export class StorageService {
  private storageSignal = signal(localStorage.getItem('activeState') || ''); // Signal to store data
  private languageSignal = signal(localStorage.getItem('language') || 'en'); // Signal to store data

  constructor() {
    // Listen to the 'storage' event (cross-tab updates)
    fromEvent<StorageEvent>(window, 'storage').subscribe(event => {
      if (event.key === 'activeState') {
        this.storageSignal.set(event.newValue || '');
      }
      if (event.key === 'language') {
        this.languageSignal.set(event.newValue || '');
      }
    });
  }

  // Method to update localStorage from any component
  updateStorage(value: string) {
    localStorage.setItem('activeState', value);
    this.storageSignal.set(value); // Manually update signal for same-tab changes
  }

  updateLangStorage(value: string) {
    localStorage.setItem('language', value);
    this.languageSignal.set(value); // Manually update signal for same-tab changes
  }

  // Method to get storage signal
  get storage() {
    return this.storageSignal;
  }

  get storageLang() {
    return this.languageSignal;
  }
}
